<template>
  <div class="modal_coords">
    <div class="modal_coords__header">
      <h4 class="title">
        {{ coords.lat ? translate('device.coords.update_coord') : translate('device.coords.add_coord') }}
      </h4>
    </div>
    <div class="content">
      <div class="line">
        <fg-input
            class="item"
            v-model="new_coords.lat"
            type="number"
            :label="translate('device.coords.lat')"
            :placeholder="translate('device.coords.lat')"
        />
        <fg-input
            class="item"
            v-model="new_coords.long"
            type="number"
            :label="translate('device.coords.long')"
            :placeholder="translate('device.coords.long')"
        />
      </div>

      <div class="line">
        <fg-input
            class="item"
            v-model="new_coords.address"
            type="text"
            :label="translate('device.coords.address')"
            :placeholder="translate('device.coords.address')"
        />
      </div>
    </div>

    <div class="text-center">
      <span
          :disabled="!check_change"
          class="btn btn-success btn-fill btn-wd marginButton"
          @click.prevent="updateCoords()"
      >
        {{ translate("save") }}
      </span>

      <span
          class="btn btn-warning btn-fill btn-wd marginButton"
          @click.prevent="cancel"
      >
        {{ translate("close_modal") }}
      </span>

      <span
          class="btn btn-danger btn-fill btn-wd marginButton"
          @click.prevent="pre_remove_coords"
          v-if="check_remove"
      >
        {{ translate("coord.remove_coord") }}
      </span>
    </div>
  </div>
</template>
<script>
import GlobalConfirm from "../../../../../../../../components/UIComponents/Confirm/GlobalConfirm.vue";

export default {
  name:"DeviceCoord",
  props: [
    "coords",
    "device_id",
    "device_fid"
  ],
  data() {
    return {
      acceptConf: false,
      new_coords: {
        lat: null,
        long: null,
        address: ""
      },
    };
  },
  created() {
    this.new_coords = { ...this.coords };
  },
  computed: {
    check_change() {
      return JSON.stringify(this.new_coords) !== JSON.stringify(this.coords);
    },
    check_remove(){
      return (this.coords.lat && String(this.coords.lat) !== "")
    }
  },
  watch:{
    new_coords:{
      deep: true,
      handler(){
        this.new_coords.lat = Number(this.new_coords.lat)
        this.new_coords.long = Number(this.new_coords.long)
      }
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },
    updateCoords() {
      if (this.check_change){
        this.$http.v1.updateDeviceCoord({device_id: this.device_id, ...this.new_coords},() => {
          this.global_notify("info", this.translate("profile_saved"));
          this.$emit("update_coords")
        });
      }
    },
    remove_coord() {
      this.$http.v1.removeDeviceCoord(this.device_fid,(response) => {
        if (!response.data) this.global_notify("info", this.translate("coord.remove_coord_error"));

        this.global_notify("info", this.translate("coord.remove_coord_success"));
        this.$emit("update_coords")
      });
    },
    pre_remove_coords() {
      let t = this.$createElement(GlobalConfirm, {
        props: {
          text: this.translate('coord.remove_coord_question')
        },
        on: {
          close: () => {
            this.$modal.hide('remove_coord')
          },
          confirm: () => {
            this.remove_coord()
            this.$modal.hide('remove_coord')
          }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: false, scrollable: true, name: 'remove_coord'})

    },
  },
};
</script>

<style lang='scss'>
.modal_coords {
  padding: 10px;
  &__header{
    display: flex;
    align-items: center;
    justify-content: center;
    .title{
      margin: 0 0 10px;
    }
  }
  .line{
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    .item{
      width: 100%;
      margin-right: 10px;
      &:last-child{
        margin-right: 0;
      }
    }
  }
}
</style>
